// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1464Z","rootSmall":"AddTileButton_rootSmall__31SMP"};